import * as React from 'react'
import useStyleDeleteExtensionModal from './Styles/useStyleDeleteExtensionModal'
import CloseIcon from '@mui/icons-material/Close'
import { Modal } from '@mui/material'
import { Box } from '@mui/system'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { deleteFileExtends } from '../../../../redux/actions/Security'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 200,
  bgcolor: 'white',
  p: 4,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export default function DeleteExtensionModal ({
  openDeleteModal,
  setOpenDeleteModal,
  extendSelected
}) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleClose = () => {
    setOpenDeleteModal(false)
  }

  const handleDeleteExtend = async () => {
    try {
      await dispatch(deleteFileExtends(extendSelected))
      setOpenDeleteModal(false)
      setTimeout(() => {
        navigate(0)
      }, 2000)
    } catch (error) {
      console.log(error)
    }
  }

  const classes = useStyleDeleteExtensionModal()

  return (
    <div>
      <Modal
        open={openDeleteModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: 'medium',
              ml: 50,
              color: '#263057',
              cursor: 'pointer'
            }}
            onClick={handleClose}
          />
          <Typography
            sx={{ fontFamily: 'Raleway', color: '#263057' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Eliminar extensión
          </Typography>
          <Typography
            id="modal-modal-description"
            className={classes.typography}
          >
            ¿Desea deshabilitar esta extensión?
          </Typography>
          <Box className={classes.buttons}>
            <ButtonConfirm handleDeleteExtend={handleDeleteExtend} />
            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
function ButtonConfirm ({ handleDeleteExtend }) {
  const classes = useStyleDeleteExtensionModal()
  return (
    <Box
      className={classes.confirmButton}
      sx={{
        '&:hover': {
          bgcolor: '#1BF57F'
        }
      }}
    >
      <Typography
        onClick={handleDeleteExtend}
        className={classes.confirmButtonTypography}
      >
        ELIMINAR
      </Typography>
    </Box>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyleDeleteExtensionModal()
  return (
    <Box className={classes.closeButton}>
      <Typography
        onClick={() => {
          handleClose()
        }}
        className={classes.closeButtonColor}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
